import get from 'lodash/get';
import {
  Body,
  CategoryData,
  Estate,
  LiquidityKeys,
  EstateKeys,
  ValueLessHeaderId,
} from '../FlowTable.meta';
import { getLiquidity } from './getLiquidity';

interface GetEstateParams {
  data: CategoryData;
  accumulator: Body;
  estateKey: EstateKeys;
}

export const getEstate = ({ data, accumulator, estateKey }: GetEstateParams): Estate => {
  return {
    ...get(accumulator, [estateKey], {}),
    name: data[estateKey]?.inOutEstateText,
    id: data[estateKey]?.inOutEstate,
    totals: [
      ...get(accumulator, [estateKey, 'totals'], []),
      ...(data.headerId !== ValueLessHeaderId.Summary
        ? [
            {
              headerId: data.headerId,
              collapsed: data.collapsed,
              value: get(data, [estateKey, 'total'], null),
              headerName: data.headerName,
            },
          ]
        : []),
    ],

    liquidAssets: getLiquidity({
      data,
      accumulator,
      liquidityKey: LiquidityKeys.LiquidAssets,
      estateKey,
    }),

    illiquidAssets: getLiquidity({
      data,
      accumulator,
      estateKey,
      liquidityKey: LiquidityKeys.IlliquidAssets,
    }),
  };
};
